module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEnSURBVHgBrVTRsYIwENzn81/sICVYAlYgHYgd2IHagVagHWgHjH/+oRVAB9qB3g0XPSOQ4LgzOwnHsndeLgJhiIgLYkG8C3OJGXTElHhVRoVjzPsk1CxRHy6lUgtD3Kn3sc/MqErSFl2qKo0QINzCj0y0SYho1JBormKxTd5rMbTln524TTBRsVJWgxbkkjWqSZQ48ZFos15LdZESa9yIB1nhaC5NZra6HJ6Tk/d2GswvzKx+29WM+8YnG8uer921Se8zm+J1I1yutf5PHnjmuLE8ImNUDTc15hu1L1FdvZuT/DnA7sexxPlncdNTBMJ+pMeEG7xH+NX7MCzU8w7vPQr+a2L01d7IOpB1hqqnZ3REhvrT881gLf6JR+IQ1WmVwhXxhC/wAFKCa5EU5R9gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/icon-password.png
// module id = jXRo
// module chunks = 0